var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.jointGoodsModel.isRest)?_c('x-bottom-bar',[_c('div',{class:_vm._.block},[_vm._v("店铺休息中")])]):(_vm.jointGoodsModel.isClosed)?_c('x-bottom-bar',[_c('div',{class:_vm._.block},[_vm._v("店铺已停业")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }